import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

export default function AboutPage() {
  const { t } = useI18n();
  return (
    <div className="pt-28 md:pt-36 pb-20 bg-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-20">
          <div className="md:col-span-5">
            <div className="label-eyebrow mb-3">{t.about.eyebrow}</div>
            <h1 className="font-display font-medium text-slate-900 text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight">{t.about.title}</h1>
          </div>
          <div className="md:col-span-6 md:col-start-7 space-y-5 text-slate-700 text-lg leading-relaxed">
            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>{t.about.p1}</motion.p>
            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.1 }}>{t.about.p2}</motion.p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6">
          {t.about.values.map((v, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.06 }}
              className="card-hover p-6 md:p-8 border border-slate-200 rounded-xl bg-white">
              <div className="label-eyebrow text-[var(--steel)] mb-3">0{i + 1}</div>
              <h3 className="font-display text-slate-900 text-xl md:text-2xl leading-tight mb-2 tracking-tight">{v.t}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{v.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
